import type { MapViewType } from '../../../../app-kit/components/PcaMap/types';
import type { GeoJsonData } from '../../../../app-kit/components/PcaMap/PcaMap';
import { addPropertyMapGeoJson } from './addPropertyMapGeoJson';
import { useShowLocationInStreetView } from './useShowLocationInStreetView';
import { useContext } from 'react';
import { trackMapTypeChanged } from '../../../../analytics/event-tracking/trackMapTypeChanged';
import { PcaMapContext } from '../../../contexts/PcaMapContext/PcaMapContext';

interface useMapTypeChangeProps {
  propertyBoundary?: GeoJsonData | null;
  buildingBoundaries?: GeoJsonData | null;
}

export const useChangeMapType = ({
  propertyBoundary,
  buildingBoundaries,
}: useMapTypeChangeProps) => {
  const { google, map, initialConfig } = useContext(PcaMapContext);
  const location = initialConfig?.center;

  const showLocationInStreetView = useShowLocationInStreetView();

  return (mapType: MapViewType) => {
    if (!map || !google || !location) return;

    // Remove all current map features
    map.data.forEach((feature) => map.data.remove(feature));

    switch (mapType) {
      case 'satellite': {
        map.getStreetView().setVisible(false);
        map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
        addPropertyMapGeoJson(map, propertyBoundary);
        trackMapTypeChanged({ map_type: 'satellite' });
        return;
      }
      case 'street_view': {
        showLocationInStreetView();
        trackMapTypeChanged({ map_type: 'street_view' });
        return;
      }
      case 'roadmap':
      default: {
        map.getStreetView().setVisible(false);
        map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
        addPropertyMapGeoJson(map, propertyBoundary, buildingBoundaries);
        trackMapTypeChanged({ map_type: 'roadmap' });
      }
    }
  };
};
